import { withStyles, StyleRulesCallback, Theme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Downshift from "downshift";
import * as React from "react";
import { LocationNameModel } from "../../common/models/CommonModels";
import * as locationApi from "../../api/locationsApi";

const styles: StyleRulesCallback<Theme, object> = (theme: Theme) => ({
    root: {
        position: "relative",
        // width: 600
    },
    container: {
        position: 'relative',
        width: "auto",
        marginLeft: "26px",
        marginRight: "26px"
    },
    paper: {
        position: "absolute",
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    formChild: {
        position: 'relative',
        // marginTop: theme.spacing.unit * 2,

    },
    inputRoot: {

    },
    checkBox: {
        marginLeft: 0
    }
});

const itemToString = (item: LocationNameModel) => {
    return item ? item.name : "";
}

export const CitySuggestionDropDown = withStyles(styles)(({ label, ...input }: any) => {
    const { classes } = input;

    return <Downshift onChange={input.onChange} itemCount={3} itemToString={itemToString} selectedItem={input.value}>
        {({ getInputProps, getItemProps, isOpen, selectedItem, inputValue, highlightedIndex }) => (
            <div className={classes.formChild}>
                {renderInput({
                    disabled: input.disabled,
                    fullWidth: true,
                    classes,
                    label: `${label}`,
                    required: input.required,
                    InputProps: getInputProps({
                        placeholder: `${label}`,
                        id: 'integration-downshift-simple',
                    }),
                })}
                {isOpen ? (
                    <Paper className={classes.paper} square>
                        {getSuggestions(inputValue).map((suggestion, index) =>
                            renderSuggestion({
                                suggestion,
                                index,
                                itemProps: getItemProps({ item: suggestion }),
                                highlightedIndex,
                                selectedItem,
                            }),
                        )}
                    </Paper>
                ) : null}
            </div>
        )}
    </Downshift>
});

function renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }: any) {
    const isHighlighted = highlightedIndex === index;
    const isSelected = (selectedItem ? selectedItem.name : '' || '').indexOf(suggestion.name) > -1;

    return (
        <MenuItem
            {...itemProps}
            key={suggestion.id}
            selected={isHighlighted}
            value={suggestion.id}
            component="div"
            style={{
                fontWeight: isSelected ? 500 : 400,
            }}
        >
            {suggestion.name}
        </MenuItem>
    );
}

let suggestionFetched: boolean;
let suggestionList: LocationNameModel[] = [
];

const suggestions = () => {
    return suggestionFetched ? suggestionList : fetchSuggestions();
};

const fetchSuggestions = () => {
    locationApi.getLocationNames().then(data => {
        suggestionFetched = true;
        suggestionList = data;
    });

    return suggestionList;
}

function renderInput({ disabled, ...inputProps }: any) {
    const { InputProps, classes, ref, label, ...other } = inputProps;
    return (
        <TextField
            disabled={disabled}
            label={label}
            InputLabelProps={{
                shrink: true
            }}
            InputProps={{
                inputRef: ref,
                ...InputProps,
            }}
            {...other}
        />
    );
}

interface MatchItem<T> {
    item: T;
    name: string;
    matchRate: number;
}

const sortMatches = (a: MatchItem<LocationNameModel>, b: MatchItem<LocationNameModel>) => {
    return a.matchRate > b.matchRate ? 1 : b.matchRate > a.matchRate ? -1 : 0;
}

function getSuggestions(inputValue: any) {
    const inputLength = inputValue ? inputValue.length : 1;

    const matches: Array<MatchItem<LocationNameModel>> = suggestions().filter(suggestion => (!inputValue || suggestion.name.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1)).map(item => {
        const matchRate = inputLength / item.name.length;

        return {
            item,
            name: item.name,
            matchRate
        };
    })

    return matches.sort(sortMatches).reverse().splice(0, 5).map(item => item.item);
}


// WEBPACK FOOTER //
// ./src/components/forms/CitySuggestionDropDown.tsx